import { CALL_API } from '../middleware/api';

// Get Blogs
export const GET_BLOGS_REQUEST = 'GET_BLOGS_REQUEST';
export const GET_BLOGS_SUCCESS = 'GET_BLOGS_SUCCESS';
export const GET_BLOGS_FAILURE = 'GET_BLOGS_FAILURE';

export const getBlogs = () => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			endpoint: `blogs`,
			options: {
				method: 'GET',
				headers: {
					Accept: 'application/json',
				},
			},
			types: [GET_BLOGS_REQUEST, GET_BLOGS_SUCCESS, GET_BLOGS_FAILURE],
		},
	});
};

// Get Blog
export const GET_BLOG_REQUEST = 'GET_BLOG_REQUEST';
export const GET_BLOG_SUCCESS = 'GET_BLOG_SUCCESS';
export const GET_BLOG_FAILURE = 'GET_BLOG_FAILURE';

export const getBlog = (id) => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			endpoint: `blogs/${id}`,
			options: {
				method: 'GET',
				headers: {
					Accept: 'application/json',
				},
			},
			types: [GET_BLOG_REQUEST, GET_BLOG_SUCCESS, GET_BLOG_FAILURE],
		},
	});
};



// WEBPACK FOOTER //
// ./src/actions/blogs.js